import stringWidth from 'string-width';

/**
 * Whether a string has some full width (2 byte) characters.
 */
const hasFullWidthChars = (str: string) => stringWidth(str) > str.length;

export default hasFullWidthChars;
